<template>
  <div class="station">
    <custom-table has-organization="true" excel-type="StationBase"
                  ref="customTable" :customOptions="customOptions" :columns="columns"
                  addText="新增站点"
                  @addFn="operation({type:'add'})
    ">
      <template slot-scope="{ item, row }">
        <div v-if="item.prop === 'created'">{{
            row.created | filterTime
          }}
        </div>
        <template v-else-if="item.prop === 'startStation'">
          <el-switch :value="row.startStation" :active-value="1" :inactive-value="0"
                     @click.native="updateStation(row)">
          </el-switch>
        </template>
        <div v-else>{{ row[item.prop] ? row[item.prop] : "-" }}
        </div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="140" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="operation({type:'look',row:row})">查看
            </el-button>
            <el-button type="text" @click="operation({type:'edit',row:row})">编辑
            </el-button>
            <el-button type="text" @click="operation({type:'delete',row:row})">删除
            </el-button>
          </div>
        </el-table-column>
      </template>
    </custom-table>

    <el-dialog
        :title="titleComputed"
        :before-close="handClose"
        :visible.sync="visible"
        destroy-on-close
        width="700px">
      <addStation :type="type" v-if="visible" :stationId="stationId" @handClose="handClose" @handSuccess="handSuccess"/>
    </el-dialog>
  </div>
</template>

<script>
import addStation from './components/addStation'

export default {
  name: "station",
  components: {
    addStation
  },
  computed: {
    titleComputed() {
      const title = {
        add: '创建站点',
        look: '查看站点',
        edit: '编辑站点',
      }
      return title[this.type]
    }
  },
  data() {
    return {
      visible: false,
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/station/base",
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "stationCode",
            name: "站点编码",
            value: "",
          },
          {
            type: "input",
            field: "stationName",
            name: "站点名称",
            value: "",
          },

          {
            type: "input",
            field: "mnemonicCode",
            name: "助记码",
            value: "",
          },
        ],
      },
      // 表头
      columns: [
        {prop: "stationCode", label: "站点编码",},
        {prop: "stationName", label: "站点名称",},
        {prop: "mnemonicCode", label: "助记码"},
        {prop: "stationPinyin", label: "拼音代码"},
        {prop: "startStation", label: "默认始发站"},
      ],
      stationId: '',
      type: ''
    }
  },
  methods: {
    async updateStation(row) {
      let confirm = await this.$confirm(row.startStation == 1 ? '确认关闭该机构售票窗口默认始发站' : '确认修改为该机构售票窗口默认始发站?', '默认始发站', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => {
      })
      if (confirm === 'confirm') {
        const url = '/api/v1/manage/station/base/' + row.id
        const {code} = await this.$axios.put(url, {
          startStation: row.startStation == 1 ? 0 : 1
        })
        if (code === 1) {
          this.$message.success('操作成功')
          this.$refs.customTable.listFn()
        }
      }
    },
    operation({type, row}) {
      switch (type) {
        case 'delete':
          this.removeFn({row: row})
          break
        case 'add':
          this.type = type
          this.visible = true
          break
        case 'look' :
          this.type = type
          this.stationId = row.id
          this.visible = true
          break
        case 'edit' :
          this.type = type
          this.stationId = row.id
          this.visible = true
          break
      }
    },
    handClose() {
      this.stationId = ''
      this.visible = false
    },
    handSuccess() {
      this.handClose()
      this.$refs.customTable.listFn();
    },
    async removeFn({row}) {
      let confirm = await this.$confirm('确定要删除该站点?', '删除站点', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => {
      })
      if (confirm === 'confirm') {
        let url = '/api/v1/manage/station/base/' + row.id
        let {code} = await this.$axios.delete(url)
        if (code === 1) {
          this.$message.success('删除成功')
          this.handSuccess()
        }
      }
    },
  }
}
</script>

<style scoped>

</style>